import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faGit, faJs, faHtml5, faCss3Alt, faMicrosoft, faGithub } from '@fortawesome/free-brands-svg-icons';
import WebIcon from '@mui/icons-material/Web';
import StorageIcon from '@mui/icons-material/Storage';
import CloudIcon from '@mui/icons-material/Cloud';
import CodeIcon from '@mui/icons-material/Code';
import ScienceTwoToneIcon from '@mui/icons-material/ScienceTwoTone';

const skills = [
    {
        category: 'Programming Languages',
        skills: [
            { name: 'C#', icon: <CodeIcon style={{color: '#178600'}} /> },
            { name: 'JavaScript', icon: <FontAwesomeIcon icon={faJs} style={{color: '#f7df1e'}} /> },
            { name: 'SQL', icon: <StorageIcon style={{color: '#336791'}} /> },
            { name: 'CSS', icon: <FontAwesomeIcon icon={faCss3Alt} style={{color: '#1572B6'}} /> },
            { name: 'HTML', icon: <FontAwesomeIcon icon={faHtml5} style={{color: '#E34F26'}} /> }
        ]
    },
    {
        category: '.NET Ecosystem',
        skills: [
            { name: '.NET (All frameworks)', icon: <FontAwesomeIcon icon={faMicrosoft} style={{color: '#512bd4'}} /> },
            { name: 'ASP.NET', icon: <WebIcon style={{color: '#512bd4'}} /> },
            { name: 'Entity Framework (All versions)', icon: <StorageIcon style={{color: '#512bd4'}} /> },
            { name: 'WPF', icon: <WebIcon style={{color: '#512bd4'}} /> },
            { name: 'MVC', icon: <WebIcon style={{color: '#512bd4'}} /> },
            { name: 'Razor', icon: <CodeIcon style={{color: '#512bd4'}} /> },
            { name: 'Blazor', icon: <CodeIcon style={{color: '#512bd4'}} /> }
        ]
    },
    {
        category: 'Front-End Libraries and Frameworks',
        skills: [
            { name: 'jQuery', icon: <CodeIcon style={{color: '#0769AD'}} /> },
            { name: 'React', icon: <FontAwesomeIcon icon={faReact} style={{color: '#61DAFB'}} /> }
        ]
    },
    {
        category: 'Databases',
        skills: [
            { name: 'SQL Server', icon: <StorageIcon style={{color: '#CC2927'}} /> },
            { name: 'MySQL', icon: <StorageIcon style={{color: '#4479A1'}} /> },
            { name: 'Cosmos DB', icon: <StorageIcon style={{color: '#00758F'}} /> }
        ]
    },
    {
        category: 'Cloud & DevOps',
        skills: [
            { name: 'Azure Cloud', icon: <FontAwesomeIcon icon={faMicrosoft} style={{color: '#0078D4'}} /> },
            { name: 'Azure DevOps', icon: <CloudIcon style={{color: '#0078D4'}} /> }
        ]
    },
    {
        category: 'Source Control',
        skills: [
            { name: 'Git', icon: <FontAwesomeIcon icon={faGit} style={{color: '#F05032'}} /> },
            { name: 'GitHub', icon: <FontAwesomeIcon icon={faGithub} style={{color: '#181717'}} /> }
        ]
    },
    {
        category: 'Web Development & APIs',
        skills: [
            { name: 'Web API', icon: <WebIcon style={{color: '#4A90E2'}} /> },
            { name: 'RESTful APIs', icon: <WebIcon style={{color: '#4A90E2'}} /> }
        ]
    },
    {
        category: 'Software Development Practices',
        skills: [
            { name: 'Object-Oriented Programming (OOP)', icon: <CodeIcon style={{color: '#FF5722'}} /> },
            { name: 'Software Development Lifecycle (SDLC)', icon: <CodeIcon style={{color: '#FF5722'}} /> },
            { name: 'MVC', icon: <WebIcon style={{color: '#FF5722'}} /> },
            { name: 'Unit Testing', icon: <ScienceTwoToneIcon style={{color: '#3b7a08'}} /> }
        ]
    }
];

export default skills;